<script>
import Layout from "@/router/layouts/main";
import { VclList } from "vue-content-loading";
import Stat from "@/components/widgets/stat";
import { api } from "@/state/services";

export default {
  components: { Layout, VclList, Stat },

  data() {
    return {
      usinas: [],
      loading: false,
      filtros: {
        busca: '',
        type: '',
        status: '',
      },
      fields: [
        { key: 'type',        label: 'Tipo',         sortable: true },
        { key: 'distributor', label: 'Distribuidora', sortable: true },
        { key: 'location',    label: 'Cidade/UF',     sortable: false },
        { key: 'status',      label: 'Status',        sortable: false },
        { key: 'acoes',       label: 'Ações',         sortable: false, thClass: 'text-right', tdClass: 'text-right' },
      ],
      sortBy: 'date_added',
      sortDesc: true,
      currentPage: 1,
      perPage: 25,
    }
  },

  computed: {
    usinasFiltradas() {
      return this.usinas.filter(u => {
        const busca = this.filtros.busca.toLowerCase()
        const matchBusca = !busca ||
          (u.distributor || '').toLowerCase().includes(busca) ||
          (u.city || '').toLowerCase().includes(busca)
        const matchType   = !this.filtros.type   || u.type === this.filtros.type
        const matchStatus = !this.filtros.status || u.status === this.filtros.status
        return matchBusca && matchType && matchStatus
      })
    },

    kpis() {
      const todas = this.usinas
      return [
        { icon: 'bx bx-list-ul',       title: 'Total',          value: String(todas.length) },
        { icon: 'bx bx-sun',           title: 'Fotovoltaicas',  value: String(todas.filter(u => u.type === 'fotovoltaica').length) },
        { icon: 'bx bx-water',         title: 'Hídricas',       value: String(todas.filter(u => u.type === 'hidrica').length) },
      ]
    },
  },

  mounted() {
    this.carregarDados()
  },

  methods: {
    carregarDados() {
      this.loading = true
      api
        .get('usinas')
        .then(response => {
          if (response.data.status === 'success') {
            this.usinas = response.data.list || []
          }
        })
        .finally(() => {
          this.loading = false
        })
    },

    limparFiltros() {
      this.filtros = { busca: '', type: '', status: '' }
    },

    labelTipo(type) {
      return type === 'fotovoltaica' ? 'Fotovoltaica' : 'Hídrica'
    },

    labelStatus(status) {
      const map = { pending: 'Pendente', approved: 'Aprovado' }
      return map[status] || status
    },

    badgeStatus(status) {
      const map = { pending: 'warning', approved: 'success' }
      return 'badge badge-' + (map[status] || 'secondary')
    },

    onRowClick(item, _index, event) {
      if (event && event.target && event.target.closest('a, button, .btn')) {
        return
      }
      this.$router.push('/usinas/' + item.id)
    },
  },

  watch: {
    filtros: {
      deep: true,
      handler() {
        this.currentPage = 1
      },
    },
  },
}
</script>

<template>
  <Layout>
    <ol class="breadcrumb">
      <li class="breadcrumb-item">
        <router-link tag="a" to="/">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: rgba(0, 0, 0, 1);">
            <path d="M5 22h14a2 2 0 0 0 2-2v-9a1 1 0 0 0-.29-.71l-8-8a1 1 0 0 0-1.41 0l-8 8A1 1 0 0 0 3 11v9a2 2 0 0 0 2 2zm5-2v-5h4v5zm-5-8.59 7-7 7 7V20h-3v-5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v5H5z"></path>
          </svg>
        </router-link>
      </li>
      <li class="breadcrumb-item active">Usinas</li>
    </ol>

    <div class="page-title-box d-md-flex justify-content-between">
      <div>
        <h3>Usinas</h3>
        <p></p>
      </div>
      <div>
        <router-link to="/usinas/nova" class="btn btn-primary btn-block">
          <i class="bx bx-plus mr-1"></i> Nova usina
        </router-link>
      </div>
    </div>

    <div class="row mb-3">
      <div v-for="kpi in kpis" :key="kpi.title" class="col-md-3">
        <Stat type="line" :icon="kpi.icon" :title="kpi.title" :value="kpi.value" />
      </div>
    </div>

    <div class="d-none card mb-3">
      <div class="card-body py-3">
        <div class="row">
          <div class="col-md-5 mb-2 mb-md-0">
            <input
              v-model="filtros.busca"
              type="text"
              class="form-control"
              placeholder="Buscar por distribuidora ou cidade..."
            />
          </div>
          <div class="col-md-3 mb-2 mb-md-0">
            <select v-model="filtros.type" class="form-control">
              <option value="">Todos os tipos</option>
              <option value="fotovoltaica">Fotovoltaica</option>
              <option value="hidrica">Hídrica</option>
            </select>
          </div>
          <div class="col-md-3 mb-2 mb-md-0">
            <select v-model="filtros.status" class="form-control">
              <option value="">Todos os status</option>
              <option value="pending">Pendente</option>
              <option value="approved">Aprovado</option>
            </select>
          </div>
          <div class="col-md-1">
            <button class="btn btn-secondary p-2" @click="limparFiltros">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" style="fill: currentColor;">
                <path d="m16.192 6.344-4.243 4.242-4.242-4.242-1.414 1.414L10.535 12l-4.242 4.242 1.414 1.414 4.242-4.242 4.243 4.242 1.414-1.414L13.364 12l4.242-4.242z"></path>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div v-if="loading">
          <vcl-list class="col-lg-6"></vcl-list>
        </div>

        <div v-else-if="!usinasFiltradas.length" class="text-center py-5">
          <i class="bx bx-solar-panel font-size-48 text-muted d-block mb-3"></i>
          <h5 class="text-muted">Nenhuma usina encontrada</h5>
          <p class="text-muted mb-3">Tente ajustar os filtros ou cadastre uma nova usina.</p>
          <router-link to="/usinas/nova" class="btn btn-primary btn-sm">
            <i class="bx bx-plus mr-1"></i> Nova usina
          </router-link>
        </div>

        <div v-else>
          <div class="table-responsive">
            <b-table
              :items="usinasFiltradas"
              :fields="fields"
              class="table-nowrap table-style table-hover"
              head-variant="light"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :current-page="currentPage"
              :per-page="perPage"
              responsive
              show-empty
              empty-text="Nenhuma usina encontrada"
              @row-clicked="onRowClick"
            >
              <template #cell(type)="row">
                <span>
                  <i :class="row.item.type === 'fotovoltaica' ? 'bx bx-sun text-warning' : 'bx bx-water text-primary'"></i>
                  {{ labelTipo(row.item.type) }}
                </span>
              </template>
              <template #cell(location)="row">
                {{ row.item.city }} / {{ row.item.state }}
              </template>
              <template #cell(status)="row">
                <span :class="badgeStatus(row.item.status)" class="p-1 px-2 text-white text-uppercase" style="font-size: 0.75rem; border-radius: 4px;">
                  {{ labelStatus(row.item.status) }}
                </span>
              </template>
              <template #cell(acoes)="row">
                <router-link
                  :to="'/usinas/' + row.item.id"
                  class="btn btn-sm btn-default"
                  @click.native.stop
                >
                  Ver
                </router-link>
              </template>
            </b-table>
          </div>
          <b-pagination
            v-if="usinasFiltradas.length > perPage"
            v-model="currentPage"
            :total-rows="usinasFiltradas.length"
            :per-page="perPage"
            pills
            align="center"
            class="mt-3 mb-0"
          />
        </div>
      </div>
    </div>
  </Layout>
</template>
